import parseUrl from 'url-parse';
import * as API from '@/api/assistApi';
import $ from 'jquery';
import config from '@/config';

let ua = window.navigator.userAgent.toLowerCase() || '';
let isAndroid = ua.indexOf('android') > -1 || ua.indexOf('linux') > -1; // 安卓

function timeStr(time){
  let str;
  if(time>60){
    str = parseInt(time/60)+"小时"+parseInt(time%60)+"分钟"
     
  }else if(time>0) {
    str = parseInt(time)+"分钟"
  }else{
    str = ""
  }
  return str;
}
//时间格式转化
function dateFormat(fmt, d) {
  let date = new Date(d);
  let ret;
  const opt = {
      "Y+": date.getFullYear().toString(),        // 年
      "m+": (date.getMonth() + 1).toString(),     // 月
      "d+": date.getDate().toString(),            // 日
      "H+": date.getHours().toString(),           // 时
      "M+": date.getMinutes().toString(),         // 分
      "S+": date.getSeconds().toString()          // 秒
      // 有其他格式化字符需求可以继续添加，必须转化成字符串
  };
  for (let k in opt) {
      ret = new RegExp("(" + k + ")").exec(fmt);
      if (ret) {
          fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
      };
  };
  return fmt;
}
// time单位为秒
function time2format(time , type = 'en' ) { 
  //   console.log('时间',time);
  //   console.log('时间',type);

  var h = 0
  if(time>3600){
      h = Math.floor(time / 3600)
      var m = Math.floor((time-h*3600) / 60)
        var s = Math.floor((time-h*3600) % 60)
  }else{
      var m = Math.floor(time / 60)
        var s = Math.floor(time % 60)
  }
    
    if (s < 10) {
        s = "0" + s
    }
  if(m<10){
      m = '0' + m;
  }
  if(h<10){
      h = '0' + h;
  }
  var timestring = '';
  if(type == 'en'){
      timestring = h+':'+ m + ':' + s;
  }else{
      timestring = h+'时'+ m + '分' ;
  }
  return timestring;
}

function pullGame (applink) {
  let channel = MG.utils.getQueryString('channel') || ''
  let channelQuery = channel ? '?channel=' + channel : ''
  let applinkQuery ='';
  if(applink){
    applinkQuery = 'applink=' + encodeURIComponent(applink) 
  }
  if(!channelQuery){
    window.location.href="http://www.migufun.com/h5/cloudgame/appdownload/appDownload.html?"+applinkQuery;
  }else{
    window.location.href = 'http://www.migufun.com/h5/cloudgame/appdownload/appDownload.html' + channelQuery + '&' + applinkQuery
  }
}

// 在微信中提示在浏览器中打开
function showWxModal () {
  let wxModal = '<div class="wx-modal"></div>';
  $('#app > div').append(wxModal)
  $('.wx-modal').click(function() {
    $(this).hide();
  })
}

function isIos() {
  //判断手机系统类型
  var UA = window.navigator.userAgent.toLowerCase() || '';
  var isIos=UA.match(/iPhone|iPad|iPod/i) ? true : false;
  return isIos;
}

// 拉起App
function openApp(appLink, downloadUrl){
  //判断手机系统类型
  var UA = window.navigator.userAgent.toLowerCase() || '';
  var isIos=UA.match(/iPhone|iPad|iPod/i) ? true : false;
  var packageChannel = MG.utils.getQueryString('packageChannel') || 'aOn'
  //获取参数链接
  var isWechat = UA.match(/MicroMessenger/i) == "micromessenger" || UA.match(/QQ\//i) == "qq/" || UA.match(/WeiBo/i) == "weibo";
  if (isWechat) {
    showWxModal();

  }else if(isIos){
    API.getIosGuideType().then((res)=>{
      if(res.data.returnCode=="000000"){
        var guideType = res.data.resultData.iosGuideType;
        if(guideType==1 || guideType==2){
          window.location.href = 'https://beta.migufun.com/migugameuniversallink/' + appLink
        }else{
          window.location.href = 'https://beta.migufun.com/enterpriseuniversallink/' + appLink
        }
      }
    })
    return false;
  }else {
    window.location.href = `youplay://${appLink}`;
    // var iframe = document.createElement("IFRAME");
    // iframe.style.display="none";
    // iframe.setAttribute("src", schema);
    // document.documentElement.appendChild(iframe);
    // console.log(schema + appLink, '%%%%%%');
    window.setTimeout(function(){
      window.location.href = downloadUrl+"&channel="+packageChannel || 'http://g.10086.cn/h5/cloudgame/appdownload/appDownload.html';
    },5000);
  
  }
}

function openinnerApp(appLink){
  var schema = "youplay://";
  window.location.href = schema + appLink;
}

// 弹出提示信息
function popMessage (param , time) {
  let message = `<div class="pop-message"><p>${param}<p/><p>${time || ''}<p/></div>`
  $('#app > div').append(message)
  setTimeout(() => {
    $('.pop-message').remove()
  }, 2000)
}

// 防抖函数
function throttle(fn, interval = 1000) {
  let last = 0;

  return function(...args) {
    let now = +new Date();

    if (now - last >= interval) {
      last = now;
      fn.apply(this, args);
    }
  };
}

/***禁止滑动***/
function stopBodyScroll(){
  document.body.style.overflow='hidden';        
}

/***取消滑动限制***/
function bodyScroll(){
  document.body.style.overflow='';//出现滚动条
}

function isMiguApp() {
  const ua = window.navigator.userAgent;
  return ua.indexOf('miguplay') !== -1;
}

function toLogin(backUrl = window.location.href) {
    MiguplayUtils.user.gotoLogin(backUrl);
    return;
    const inMiguApp = isMiguApp();
    if (inMiguApp) {
        let ua = window.navigator.userAgent.toLowerCase() || "";
        let isAndroid = ua.indexOf("android") > -1 || ua.indexOf("linux") > -1; // 安卓
        if (isAndroid) {
            // 安卓
            console.log("安卓", window.JSInterface)
            window.JSInterface.requestNativeLogin();
        } else {
            //ios
            console.log("ios")
            window.webkit.messageHandlers.requestNativeLogin.postMessage("");
        }
    } else {
        window.location.href = `${config.loginUrl}login?sourceid=206026&apptype=2&forceAuthn=true&isPassive=false&authType=DS&display=wap&callbackURL=${window.encodeURIComponent(backUrl)}`;
    }
}



function isLatestVersion({androidV, iosV, companyV}) {
  const appVersion = localStorage.getItem('appversion') || '';

  var ua = window.navigator.userAgent || '';
  var isAndroid = ua.indexOf("Android") > -1 || ua.indexOf("Linux") > -1; // 安卓
  if (isAndroid) {
    const versionArr = appVersion.split('.');
    let androidApp = versionArr[0]*100 + versionArr[1]*1;
    console.log("安卓", androidApp)
    return {
      versionType: 'android',
      isLatest: androidV && androidApp >= androidV,
    }
  } else {
    let iosApp = appVersion.split('.');
    if (iosApp[0].length == 1) { //appstore
      let compara = iosApp[0] * 10000 + iosApp[1] * 100 + iosApp[2]*1;
      console.log("APP", compara)
      return {
        versionType: 'appstore',
        isLatest: iosV && compara >= iosV,
      };
    } else { //企业包
      let compara = iosApp[0] * 10000 + iosApp[1] * 100 + iosApp[2]*1;
      console.log("企业",iosApp, compara, companyV)
      return {
        versionType: 'iosCompany',
        isLatest: companyV && compara >= companyV,
      }
    }
  }
}

function fullScreen(){
  let ua = window.navigator.userAgent.toLowerCase() || "";
  let isAndroid = ua.indexOf("android") > -1 || ua.indexOf("linux") > -1; // 安卓
  document.body.style.paddingTop = 0;
  document.body.style.paddingBottom = 0;
  if (isAndroid) {
    // 安卓
    try {
      window.JSInterface.transparentnavigationbar();
    } catch (error) {
      console.log(error);
    }
  } else {
    //ios
    try {
      window.webkit.messageHandlers.transparentnavigationbar.postMessage('');
    } catch (error) {
      console.log(error);
    }
  }
}

function getspic(url){
  let rep = new RegExp(/http/);
  if(!rep.test(url)){
      url = 'https://freeserver.migufun.com/resource/beta' + url;
  }
  let spic = url.replace(/(\.jpeg)|(\.jpg)|(\.png)/,"_sdpic$1$2$3");
  // console.log('*****************************');
  // console.log(spic);
  return spic;
}

function getAppDeviceId() {
  if (isAndroid) {
    // 安卓
    try {
      window.JSInterface.getDeviceID();
    } catch (error) {
      console.log(error);
    }
  } else {
    //ios
    try {
      window.webkit.messageHandlers.getDeviceID.postMessage('');;
    } catch (error) {
      console.log(error);
    }
  }
}
/* 获取页面search */
function gethash(){
  var url = window.location.search;
  if(url=='')return false;
  url = url.replace("\?","");
  url = url.replace(/\./g,"_");
  url = url.split("&");
  var _u={};
  for(var i=0;i<url.length;i++){
      var item = url[i].split("=");
      eval('_u.'+item[0]+'=item[1]');
  }
  return _u;
}

//时间格式转化
function getTime(time){
  let dates = new Date(time);
  let obj = {
    year:'',
    month:'',
    day:'',
    hour:'',
    minute:''
  }
  obj.year=dates.getFullYear();
  obj.month=dates.getMonth()+1>=10?dates.getMonth()+1:'0'+(dates.getMonth()+1);
  obj.day=dates.getDate()>=10?dates.getDate():'0'+dates.getDate();
  obj.hour=dates.getHours();
  obj.minute=dates.getMinutes()>10?dates.getMinutes():'0'+dates.getMinutes();
  // let arr =time.split(" ")
  return obj;
}

function share(shareId) {
  let ua = window.navigator.userAgent.toLowerCase() || "";
  let isAndroid = ua.indexOf("android") > -1 || ua.indexOf("linux") > -1; // 安卓
  if (isAndroid) {
    // 安卓
    window.JSInterface.share(shareId);
    return;
  } else {
    //ios
    window.webkit.messageHandlers.share.postMessage(`${shareId}`);
    return;
  }
}



function getUrlQuery(url = window.location.href) {
  return parseUrl(url, true).query
}
//去除URL中userId userToken
function moveQuery(){
  const queryObj ={
    ...getUrlQuery(),
  };
  var joinData = ""
  for (let key in queryObj){
    if (key !="userId" && key !="userToken") {
      if (joinData) {
        joinData = joinData +"&"+ key +"="+queryObj[key]
      }else{
        joinData = joinData + key +"="+queryObj[key]
      }
    }
  }
  let pathname = location.pathname
  if (joinData) {
    return `${pathname}?${joinData}`;
  }else{
    return `${pathname}`;
  }
}

function storeUserInfo() {
  const inMiguApp = isMiguApp();
  const userId = MG.utils.getQueryString('userId') || '';
  const userToken = MG.utils.getQueryString('userToken') || '';
  localStorage.setItem('userId', userId);
  localStorage.setItem('userToken', userToken);
  if (userId && !inMiguApp) {
    window.location.href = moveQuery();
  }
}

module.exports = {
  dateFormat:dateFormat,
  time2format:time2format,
  timeStr:timeStr,
  openApp:openApp,
  openinnerApp:openinnerApp,
  popMessage:popMessage,
  throttle,
  stopBodyScroll,
  bodyScroll,
  toLogin,
  isMiguApp,
  isLatestVersion,
  fullScreen,
  getspic,
  getAppDeviceId,
  isIos,
  gethash,
  getTime,
  share,
  storeUserInfo,
}



// WEBPACK FOOTER //
// ./src/utils/utils.js